import type { TyreVehicleKind } from '@chukua/common';
import { useVehicleTyreActions } from './use-vehicle-tyre-actions';
import { useVehicleTyreLayout } from './use-vehicle-tyre-layout';

/** One vehicle of a rig: its tyre layout and the moves started from it, each sent for that vehicle alone. */
export function useRigVehicleTyres(vehicleKind: TyreVehicleKind, vehicleId: string) {
  const { state, reload } = useVehicleTyreLayout(vehicleKind, vehicleId);
  const actions = useVehicleTyreActions({ vehicleKind, vehicleId, layout: state.status === 'loaded' ? state.layout : null, reload });
  return { state, actions };
}
